import './ProfileItem.scss';

import React, { memo } from 'react';

import { Typography } from 'antd';

import CreatorTag from '../CreatorTag/CreatorTag';

export interface ProfileTitleProps {
  title: React.ReactNode;
  isCreator?: boolean;
  creatorTagText?: string;
  onClick?: () => void;
  titleStyle?: React.CSSProperties;
  creatorTagStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  avatar?: React.ReactNode;
}

const ProfileTitle: React.FC<ProfileTitleProps> = ({
  title,
  isCreator = false,
  creatorTagText = 'Creator',
  onClick,
  titleStyle,
  creatorTagStyle,
  style,
  avatar,
}) => {
  return (
    <div
      className="profile__title"
      style={{
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
      onClick={onClick}>
      {avatar && isCreator ? (
        <div className="profile__title__avatar">{avatar}</div>
      ) : null}
      <Typography.Title
        level={5}
        className="profile__title__text"
        ellipsis={{
          rows: 1,
          tooltip: typeof title === 'string' ? title : '',
        }}
        style={titleStyle}>
        {title}
      </Typography.Title>

      {isCreator ? (
        <>
          <br />
          <CreatorTag
            className="creator-tag profile__title__tag--creator"
            text={creatorTagText}
            style={creatorTagStyle}
          />
        </>
      ) : null}
    </div>
  );
};

export default memo(ProfileTitle);
